<script setup lang="ts">
import { HTMLAttributes } from 'vue';

defineProps</* @vue-ignore */ HTMLAttributes>();
</script>
<template>
  <svg viewBox="0 0 142 23" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M136.301 3.2131L142.007 19.5502V19.7869H137.887L136.916 16.6379H130.76L129.789 19.7869H125.859V19.5502L131.542 3.2131H136.301ZM131.778 13.3705H135.898L133.886 6.93037H133.791L131.778 13.3705Z"
    />
    <path
      d="M117.804 20C112.476 20 109.777 16.2354 109.777 11.5237C109.777 6.74095 112.476 3 117.804 3C122.042 3 124.907 5.95961 125.144 9.46379H121.355C121.213 7.87744 120.124 6.36212 117.804 6.36212C115.057 6.36212 113.566 8.18524 113.566 11.5237C113.566 14.8621 115.057 16.6616 117.804 16.6616C120.029 16.6616 121.095 15.2646 121.379 13.702H125.144C124.812 17.1114 122.018 20 117.804 20Z"
    />
    <path d="M103.672 19.7869V3.2131H107.413V19.7869H103.672Z" />
    <path
      d="M82.8394 19.7869V3.2131H86.9118L91.5761 10.8134H91.6708L96.3352 3.2131H100.36V19.7869H96.7614V9.08497H96.6667L91.7182 17.0404H91.4814L86.533 9.01394H86.4382V19.7869H82.8394Z"
    />
    <path
      d="M76.9456 13.4889L80.947 19.5502V19.7869H76.5905L73.0153 13.9387H70.6949V19.7869H66.9777V3.2131H74.5543C78.0821 3.2131 80.213 5.6755 80.213 8.49305C80.213 10.8844 78.9582 12.6839 76.9456 13.4889ZM70.6949 6.52787V10.624H74.3648C75.8565 10.624 76.4011 9.55851 76.4011 8.51673C76.4011 7.5223 75.8091 6.52787 74.3648 6.52787H70.6949Z"
    />
    <path
      d="M56.5543 20C51.2033 20 48.5042 16.2354 48.5042 11.5C48.5042 6.74095 51.2033 3 56.5543 3C61.8816 3 64.6044 6.74095 64.6044 11.5C64.6044 16.2354 61.8816 20 56.5543 20ZM56.5543 16.6379C59.3008 16.6379 60.8161 14.8384 60.8161 11.5C60.8161 8.16156 59.3008 6.36212 56.5543 6.36212C53.7841 6.36212 52.2925 8.16156 52.2925 11.5C52.2925 14.8384 53.8078 16.6379 56.5543 16.6379Z"
    />
    <path
      d="M35 19.7869V3.2131H46.8384V6.52787H38.7173V10.0557H46.1045V13.3705H38.7173V19.7869H35Z"
    />
    <mask
      id="mask0_41_1054"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="26"
      height="23"
    >
      <path d="M25.4312 0H0V23H25.4312V0Z" />
    </mask>
    <g mask="url(#mask0_41_1054)">
      <path
        d="M17.2508 3.65788e-06H8.17144C6.87434 0.00176311 5.67612 0.693484 5.02595 1.81588L0.487289 9.68464C-0.163081 10.8111 -0.163081 12.199 0.487289 13.3255L5.02696 21.1851C5.67858 22.31 6.88053 23.0021 8.18052 23.001H17.2599C18.5595 23.0018 19.761 22.3097 20.4124 21.1851L24.9521 13.3255C25.6027 12.199 25.6027 10.8111 24.9521 9.68464L20.4064 1.81588C19.7544 0.690366 18.5515 -0.00183602 17.2508 3.65788e-06Z"
      />
    </g>
    <path
      class="primary-fill"
      d="M11.7652 6.09835C12.5685 5.80768 13.4166 6.40273 13.4166 7.25697V7.35392L9.84289 8.6471C9.02976 8.94134 8.48807 9.71342 8.48807 10.5781V13.6195C7.68734 13.9029 6.84521 13.309 6.84521 12.4578V9.12738C6.84521 8.37795 7.31468 7.70881 8.01939 7.45381L11.7652 6.09835ZM13.9557 7.74124C14.759 7.45057 15.6071 8.04562 15.6071 8.89986V8.9968L11.8527 10.3554C11.148 10.6103 10.6785 11.2795 10.6785 12.0289V15.2624C9.87782 15.5458 9.03569 14.9519 9.03569 14.1007V10.5782C9.03569 9.94403 9.43293 9.37784 10.0292 9.16207L13.9557 7.74124ZM16.1462 9.38409C16.9494 9.09342 17.7976 9.68847 17.7976 10.5427V14.2574C17.7976 14.7762 17.4726 15.2395 16.9847 15.416L12.8776 16.9022C12.0743 17.1928 11.2262 16.5978 11.2262 15.7435V12.0289C11.2262 11.5101 11.5512 11.0468 12.0391 10.8703L16.1462 9.38409Z"
    />
  </svg>
</template>
<style scoped>
svg {
  padding: var(--nxt-space-md);
  fill: none;
}

/* Follows the bar's text colour: white on the usual dark bars, dark on a
   light bar (e.g. the Nordic or Workbench Light layouts). */
path {
  fill: var(--nxt-nav-fg, white);
}

/* The dark logo lives on the nav bar, so the mark is punched out of the bar's
   own colour rather than filled with --nxt-brand-bg: two neighbouring shades of
   the same hue read as a mismatch, one reads as a cut-out. */
path.primary-fill {
  fill: var(--nxt-nav-bg);
}
</style>
